import {
    ContextMenu,
    ContextMenuContent,
    ContextMenuItem,
    ContextMenuSeparator,
    ContextMenuShortcut,
    ContextMenuSub,
    ContextMenuSubContent,
    ContextMenuSubTrigger,
    ContextMenuTrigger,
} from "@/Components/ui/context-menu"
import { PlanBuilderContext } from "../Plan";
import { useContext } from "react";
import { PageLockContext } from "@/Components/PageLockProvider";
import React from "react";
import { CharterIcon, CheckIcon, DeleteIcon, DeliverableIcon, DependenciesIcon, EditIcon, MilestoneIcon, PackageMilestoneIcon, StatusReportIcon, TaskIcon } from "@/Components/ui/Icons/TooltipIcon";
import { IndentIcon, OutdentIcon } from "lucide-react";
import { useTaskMenuLogic } from "@/Components/Plan/menus/hooks/useTaskMenuLogic";

interface TaskContextMenuProps {
    children?: React.ReactNode;
}

export function TaskContextMenu({ children }: TaskContextMenuProps) {
    const lock = useContext(PageLockContext);
    const plan = useContext(PlanBuilderContext);

    const {
        allowSetDependencies,
        allowRemove,
        allowCascade,
        allowSelected,
        allowDependents,
        canIndent,
        canOutdent,
        canComplete,
        handleSetDependencies,
        handleSetTaskType,
        handleSetFlag,
        handleDelete,
        handleCompleteTask,
    } = useTaskMenuLogic();

    if(lock.viewOnly) {
        return <ContextMenu>
                    <ContextMenuTrigger>{children}</ContextMenuTrigger>
                    <ContextMenuContent className="w-56">
                        <ContextMenuItem disabled>
                            <EditIcon />View Only Mode
                        </ContextMenuItem>
                    </ContextMenuContent>
                </ContextMenu>;
    }

    if(!plan.selectedTaskID) {
        return <ContextMenu>
                    <ContextMenuTrigger>{children}</ContextMenuTrigger>
                    <ContextMenuContent className="w-56">
                        <ContextMenuItem disabled>
                            <EditIcon />No Task Selected
                        </ContextMenuItem>
                    </ContextMenuContent>
                </ContextMenu>;
    }

    return (
        <ContextMenu>
            <ContextMenuTrigger>{children}</ContextMenuTrigger>
            <ContextMenuContent className="w-56">
                <ContextMenuItem onClick={() => handleCompleteTask()} disabled={!canComplete.canComplete}>
                    <CheckIcon />{plan.selectedTaskIDs.length > 1 ? "Complete Tasks" : "Complete Task"}
                    <ContextMenuShortcut>Alt + E</ContextMenuShortcut>
                </ContextMenuItem>
                <ContextMenuItem onClick={() => plan.setShowEditForm(true)} disabled={!plan.selectedTaskID}>
                    <EditIcon />{plan.selectedTaskIDs.length > 1 ? "Edit Tasks" : "Edit Task"}
                    <ContextMenuShortcut>Alt + E</ContextMenuShortcut>
                </ContextMenuItem>
                <ContextMenuItem disabled={!plan.selectedTaskID} onClick={() => handleDelete()} >
                    <DeleteIcon />{plan.selectedTaskIDs.length > 1 ? "Delete Tasks" : "Delete Task"}
                    <ContextMenuShortcut>Alt + D</ContextMenuShortcut>
                </ContextMenuItem>
                <ContextMenuSeparator />
                <ContextMenuItem onClick={() => plan.indentTasksUnderParent()} disabled={!canIndent.canIndent}>
                    <IndentIcon />{plan.selectedTaskIDs.length > 1 ? "Indent Tasks" : "Indent Task"}
                    <ContextMenuShortcut>Alt + I</ContextMenuShortcut>
                </ContextMenuItem>
                <ContextMenuItem onClick={() => plan.outdentTasksFromParent()} disabled={!canOutdent.canOutdent}>
                    <OutdentIcon />{plan.selectedTaskIDs.length > 1 ? "Outdent Tasks" : "Outdent Task"}
                    <ContextMenuShortcut>Alt + O</ContextMenuShortcut>
                </ContextMenuItem>
                <ContextMenuSeparator />
                <ContextMenuSub>
                    <ContextMenuSubTrigger disabled={!allowSetDependencies}  className={!allowSetDependencies ? "mr-2 opacity-50" : ""}>
                        <DependenciesIcon className={"mr-2"} /> Set Dependencies
                    </ContextMenuSubTrigger>
                    <ContextMenuSubContent className="w-48">
                        {allowCascade && <ContextMenuItem onClick={() => handleSetDependencies("cascade")}>Cascade dependencies</ContextMenuItem>}
                        {allowSelected && <ContextMenuItem onClick={() => handleSetDependencies("selected")}>Selected are dependencies of highlighted Task</ContextMenuItem>}
                        {allowDependents && <ContextMenuItem onClick={() => handleSetDependencies("dependents")}>Selected depend on highlighted Task</ContextMenuItem>}
                        {allowRemove && <ContextMenuItem onClick={() => handleSetDependencies("remove")}>Remove dependencies</ContextMenuItem>}
                    </ContextMenuSubContent>
                </ContextMenuSub>
                <ContextMenuSub>
                    <ContextMenuSubTrigger>
                        <TaskIcon className="mr-2" /> Set Type
                    </ContextMenuSubTrigger>
                    <ContextMenuSubContent className="w-48">
                        <ContextMenuItem onClick={() => handleSetTaskType("task")}><TaskIcon />Task</ContextMenuItem>
                        <ContextMenuItem onClick={() => handleSetTaskType("deliverable")}><DeliverableIcon />Deliverable</ContextMenuItem>
                        <ContextMenuItem onClick={() => handleSetTaskType("milestone")}><MilestoneIcon />Milestone</ContextMenuItem>
                        <ContextMenuItem onClick={() => handleSetTaskType("deliverableMilestone")}><PackageMilestoneIcon />Deliverable Milestone</ContextMenuItem>
                    </ContextMenuSubContent>
                </ContextMenuSub>
                <ContextMenuSub>
                    <ContextMenuSubTrigger>
                        <CharterIcon className="mr-2" /> Set Flags
                    </ContextMenuSubTrigger>
                    <ContextMenuSubContent className="w-48">
                        <ContextMenuItem onClick={() => handleSetFlag("statusReport")}><StatusReportIcon />Display on Status Report</ContextMenuItem>
                        <ContextMenuItem onClick={() => handleSetFlag("charter")}><CharterIcon />Display on Charter</ContextMenuItem>
                    </ContextMenuSubContent>
                </ContextMenuSub>
            </ContextMenuContent>
        </ContextMenu>
    )
}